
module dg.objects {
   
    angular.module('dg.objects').component('selectableItemLayout', {
        bindings: {
            propertyId: '@',
            options: '<?'
        },
        require: {
            ObjectDisplayerController: '^objectDisplayer'
        },
        controller: DisplayLayoutController,
        templateUrl: '/digmo/src/objects/properties/layouts/selectable-item-layout.html'
    });
}